<template>
    <div>
        <van-nav-bar
                title="我的提单"
                left-text=""
                right-text=""
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
        />
        <van-sticky>

            <van-search
                    class="searchwarp"
                    v-model="key"
                    placeholder="提单号\货主\仓库"
                    @blur="onSearch"
                    fixed
            >

            </van-search>
        </van-sticky>

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell @click="showBill(item)" v-for="item in list" :key="item.id" class="swipewarp">
                        <van-row gutter="20">
                            <van-col span="12">单号：{{item.outnotifyNo}}</van-col>
                            <van-col span="12" style="text-align: right">状态：{{conventStatus(item.outnotifyStatus)}}
                            </van-col>

                        </van-row>
                        <van-row gutter="20">
                            <van-col>货主：{{item.customerName}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12">货主提单号：{{item.outnotifyCustomerNo}}</van-col>
                            <van-col span="12" style="text-align: right">仓库：{{item.warehouseStoreName}}</van-col>
                        </van-row>

                        <van-row gutter="20" v-if="item.cargoname != null">
                            <van-col span="10">货品：<span v-if="item.cargoname.length<=6">{{item.cargoname}}</span>
                                <span v-if="item.cargoname.length>6">{{item.cargoname.substr(0,6)+"..."}}</span>
                            </van-col>
                            <van-col span="14" style="text-align: right;white-space: nowrap;">
                                数量：{{item.totalAmount}}件，{{item.totalWeight}}吨
                            </van-col>
                        </van-row>

                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>


        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'100%'}">
            <div class="editwarp">

                <van-nav-bar
                        title="提单详情"
                        left-text=""
                        right-text=""
                        left-arrow
                        fixed
                        @click-left="backOut()"
                />
                <div class="searchwarp" style="height: calc(100vh - 102px);">
                    <div class="van-doc-demo-block" v-if="showQueue">
                        <van-row>
                            <van-col span="12"><h2 class="van-doc-demo-block__title">排队信息</h2></van-col>
                            <van-col span="12"><h2 class="van-doc-demo-block__title" style="text-align: right;padding:5px 16px;">
                                <van-button icon="replay" size="small" plain hairline type="info" @click="showBill(detailData)" style="border:  #6685a4;">
                                    <span>刷新</span>
                                </van-button>
                            </h2></van-col>
                        </van-row>
                        <div style="background: #fff" class="pdzt">
                        <van-row style="font-weight: bold">
                            <van-col span="8" class="pdzt-cell" style="font-size: 16px">{{queueData.sort}}</van-col>
                            <van-col span="8" class="pdzt-cell" style="font-size: 16px">{{queueData.warehouseDpoint}}</van-col>
                            <van-col span="8" class="pdzt-cell">{{queueData.curStatus}}</van-col>
                        </van-row>
                        <van-row  style="color:#969799;">
                            <van-col span="8" class="pdzt-cell pdzt-cell-x">前面等待</van-col>
                            <van-col span="8" class="pdzt-cell pdzt-cell-x">业务窗口</van-col>
                            <van-col span="8" class="pdzt-cell pdzt-cell-x">当前状态</van-col>
                        </van-row>
                        </div>
                    </div>
                    <div class="van-doc-demo-block">
                        <van-row>
                            <van-col span="12"><h2 class="van-doc-demo-block__title">{{outnotify.outnotifyNo}}</h2>
                            </van-col>
                            <van-col span="12"><h2 class="van-doc-demo-block__title" style="text-align: right">
                                <span class=""><span
                                        v-if="showDetailStatus(outnotify)=='done '">完结</span>
                                    <span v-else-if="showDetailStatus(outnotify)=='verify'">审核</span></span>
                            </h2></van-col>
                        </van-row>

                        <div class="van-cell-group van-hairline--top-bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>提单日期</span></div>
                                <div class="van-cell__value"><span>{{outnotify.outnotifyDate}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>货主</span></div>
                                <div class="van-cell__value"><span>{{outnotify.customerName}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>货主提单号</span></div>
                                <div class="van-cell__value"><span>{{outnotify.outnotifyCustomerNo}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>提货仓库</span></div>
                                <div class="van-cell__value"><span>{{outnotify.warehouseStoreName}}/{{outnotify.warehouseName}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>提货车号</span></div>
                                <div class="van-cell__value"><span>{{outnotify.deliveryTrucknumber}}</span></div>
                            </div>
                        </div>
                    </div>


                    <!--                        <div>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #323233;font-weight: bold">{{outnotify.outnotifyNo}}</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right"> <span v-if="showDetailStatus(outnotify)=='done '" >完结</span>-->
                    <!--                                    <span v-else-if="showDetailStatus(outnotify)=='verify'">审核</span></van-col>-->
                    <!--                                &lt;!&ndash;<van-col span="12" style="text-align: right">状态：  <span v-if="showDetailStatus(outnotify)=='done '" >完结</span>&ndash;&gt;-->
                    <!--                                &lt;!&ndash;<span v-else-if="showDetailStatus(outnotify)=='verify'">审核</span></van-col>&ndash;&gt;-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">提单日期：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{outnotify.outnotifyDate}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="5" style="color: #727272">货主：</van-col>-->
                    <!--                                <van-col span="19" style="text-align: right">{{outnotify.customerName}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="10" style="color: #727272">货主提单号：</van-col>-->
                    <!--                                <van-col span="14" style="text-align: right">{{outnotify.outnotifyCustomerNo}}</van-col>-->
                    <!--                            </van-row>-->

                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="6" style="color: #727272">提货仓库：</van-col>-->
                    <!--                                <van-col span="18" style="text-align: right">{{outnotify.warehouseStoreName}}/{{outnotify.warehouseName}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">提货车号：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{outnotify.deliveryTrucknumber}}</van-col>-->
                    <!--                            </van-row>-->


                    <!--                        </div>-->

                    <div class="van-doc-demo-block" v-if="outnotify.cargoName != null">
                        <van-row>
                            <van-col span="12"><h2 class="van-doc-demo-block__title">提货货品</h2></van-col>
                            <van-col span="12"><h2 class="van-doc-demo-block__title" style="text-align: right"></h2>
                            </van-col>
                        </van-row>

                        <div class="van-cell-group van-hairline--top-bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>品名</span></div>
                                <div class="van-cell__value"><span>{{outnotify.cargoName}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>包装数量</span></div>
                                <div class="van-cell__value"><span>{{totalPack}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>数量</span></div>
                                <div class="van-cell__value"><span>{{totalAmount}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>重量</span></div>
                                <div class="van-cell__value"><span>{{outnotify.totalWeight}}吨</span></div>
                            </div>
                        </div>
                    </div>

                    <!--                <div style="margin-top:10px">-->
                    <!--                    <van-cell  @click="chagePhone()" title="提货货品" value=""-->
                    <!--                               title-style="font-size:16px;;font-weight: bold">-->
                    <!--                        <van-row gutter="20">-->
                    <!--                            <van-col span="12"><span class="detailLabel detailtitle"></span></van-col>-->
                    <!--                            <van-col span="12" style="text-align: right">-->

                    <!--                            </van-col>-->
                    <!--                        </van-row>-->
                    <!--                    </van-cell>-->

                    <!--                </div>-->

                    <!--                <div style="margin-top:10px">-->
                    <!--                    <van-cell class="swipewarp">-->
                    <!--                        <div>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">品名：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{outnotify.cargoName}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">包装数量：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{totalPack}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">数量：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{totalAmount}}</van-col>-->
                    <!--                            </van-row>-->
                    <!--                            <van-row gutter="20">-->
                    <!--                                <van-col span="12" style="color: #727272">重量：</van-col>-->
                    <!--                                <van-col span="12" style="text-align: right">{{outnotify.totalWeight}}吨</van-col>-->
                    <!--                            </van-row>-->
                    <!--                        </div>-->
                    <!--                    </van-cell>-->
                    <!--                </div>-->


                    <!--                <div style="margin-top:10px">-->
                    <!--                    <van-cell class="cellwarp">-->
                    <!--                        <van-row style="margin-left: 15px;line-height: 36px">-->
                    <!--                            <van-col span="20">提货明细</van-col>-->
                    <!--                            <van-col span="4" style="text-align: right;font-weight: normal;"><a>查看</a></van-col>-->
                    <!--                        </van-row>-->
                    <!--                    </van-cell>-->
                    <!--                    <van-cell class="cellitemwarp" title="" style="padding-left:30px" title-style="font-size:16px">-->
                    <!--                        <div  v-for="cargoitem in outnotify.cargo" :key="cargoitem.cargoName" class="thmx">-->
                    <!--                            <van-divider :style="{ color: '#e2e2e2', borderColor: '#e2e2e2', padding: '0 0 0 0px' }"/>-->
                    <!--                            <van-row >-->
                    <!--                                <van-col span="5"  style="line-height: 48px">{{cargoitem.cargoName}}</van-col>-->
                    <!--                                <van-col span="19" style="text-align: right">-->
                    <!--                                    <van-row >-->
                    <!--                                        <van-col style="float: right">应发：{{cargoitem.amount}}<span style="margin-left: 3px">件</span>，{{cargoitem.weight}}<span style="margin-left: 3px">吨</span></van-col>-->
                    <!--                                        <van-col style="float: right">实发：{{cargoitem.amountOut}}<span style="margin-left: 3px">件</span>，{{cargoitem.weightOut}}<span style="margin-left: 3px">吨</span></van-col>-->
                    <!--                                    </van-row>-->
                    <!--                                </van-col>-->
                    <!--                            </van-row>-->

                    <!--                        </div>-->

                    <!--                    </van-cell>-->
                    <!--                </div>-->
                    <div class="van-doc-demo-block" v-if="outnotify.balanceAmount != null">
                        <van-row style="height: 10px"></van-row>
                        <div class="van-cell-group van-hairline--top-bottom">
                            <van-cell @click="chagePhone()" title="现结费用" value="">
                                <van-row gutter="20">
                                    <van-col span="12"><span class="detailLabel detailtitle"></span></van-col>
                                    <van-col span="12" style="text-align: right;font-weight: bold;font-size: 16px">
                                        {{showMoney(outnotify.balanceAmount)}}<span style="margin-left: 3px">元</span>
                                        <!--<span v-if="outnotify.balanceStatus==0"><a style="color:#6685a4;margin-left: 15px">待结算</a></span>-->
                                        <!--<span v-else-if="outnotify.balanceStatus==1"  style="margin-left: 15px">已支付</span>-->
                                    </van-col>
                                </van-row>
                            </van-cell>
                            <van-cell v-if="isshowbook" title="质保书" is-link value="">
                                <van-row>
                                    <van-col span="12"><span class="detailLabel detailtitle"></span></van-col>
                                    <van-col span="12" style="text-align: right">
                                        <a @click="showWarrantyBook">{{outnotify.warrantyBook==undefined?0:outnotify.warrantyBook.length}}
                                        </a>
                                    </van-col>
                                </van-row>
                            </van-cell>
                        </div>
                    </div>




                </div>
                <div class="van-address-list__bottom">

                    <van-button color="#6685a4" block size="small" type="info" native-type="submit"
                                style="font-size: 16px"
                                @click="detailDel()">
                        关闭
                    </van-button>

                    <!--<van-col span="8">-->
                    <!--<van-button block size="small" type="info" native-type="submit" style="font-size: 16px"-->
                    <!--@click="detailDel()">-->
                    <!--提货预约-->
                    <!--</van-button>-->
                    <!--</van-col>-->

                </div>
            </div>
        </van-popup>


        <van-popup v-model="showWarrantypop" position="right" :style="{ height: '100%', width:'100%'}">
            <van-nav-bar
                    title="质保书"
                    left-arrow
                    fixed
                    @click-left="showWarrantypop=false"
                    z-index="9999"
            />
            <div class="editwarp">

                <van-grid :border="false" :column-num="3">
                    <van-grid-item v-for="item in outnotify.warrantyBook" :key="item.id">
                        <van-image width="100" height="100" lazy-load :src="item" @click="showImg(item)"/>
                    </van-grid-item>

                </van-grid>
            </div>
        </van-popup>


    </div>
</template>

<script>
    import {NavBar, Cell, Button, Toast, Icon, Field, Collapse, CollapseItem} from 'vant';
    import {List} from 'vant';
    import {Search} from 'vant';
    import {Col, Row} from 'vant';
    import {SwipeCell} from 'vant';
    import {Popup} from 'vant';
    import {PullRefresh} from 'vant';
    import {Sticky} from 'vant';
    import {RadioGroup, Radio} from 'vant';
    import {Calendar} from 'vant';
    import service from '../../server/index'
    import {Image as VanImage} from 'vant';
    import {ImagePreview} from 'vant';

    export default {
        name: "MyOut",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
        },
        data() {
            return {
                tel: '',
                text: '',
                digit: '',
                number: '',
                password: '',
                wximage: localStorage.getItem("userImage"),
                userName: localStorage.getItem("personName"),
                telPhone: localStorage.getItem("phoneNumber"),
                deliveryIdnumber: localStorage.getItem("deliveryIdnumber"),
                showpop: false,
                showQueue: false,
                username: '',
                smsCode: '',
                buttonTxt: "获取验证码",
                buttonStatus: false,
                smstime: 0,
                timer: -1,
                show: false,
                checked: true,
                key: "",
                list: [],
                page: 1,
                finished: false,
                loading: true,
                isLoading: false,
                outnotify: {
                    warrantyBook: []
                },
                showWarrantypop: false,
                outnotifyType: 0,
                totalAmount: "",
                totalPack: "",
                isshowbook: true,
                queueData: {},
                detailData: {},
            };
        },
        mounted() {
            this.onLoad();
        },
        computed: {
            conventStatus() {
                return function (state) {
                    if (state == 10) {
                        return "新建";
                    } else if (state == 20) {
                        return "审核";
                    } else if (state == 30) {
                        return "完结";
                    }
                }

            },
            showStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else {
                        if (item.balanceStatus == 0) {
                            return "unpay";
                        } else {
                            return "pay"
                        }
                    }
                }
            },
            showDetailStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else if (item.status == 20) {
                        return "verify"
                    }
                }
            },
            showMoney() {
                return function (cash) {
                    if (cash == null || cash == undefined) {
                        return 0
                    } else {
                        return Math.round((cash + Number.EPSILON) * 100) / 100;

                    }

                }
                // cash.toFixed(2);
                // return Math.round((cash + Number.EPSILON) * 100) / 100;
                // return cash.toFixed(2);
            }
        },
        methods: {
            back() {
                this.$router.replace("/Home/HomeMenuTh")
            },
            backOut() {
                this.showpop = false
            },
            showBill(data) {
                this.detailData = data
                let cargosName = data.cargoname

                let param = {}
                param.appid = data.appid
                param.outnotifyId = data.outnotifyId
                param.outnotifyType = data.outnotifyType
                param.queueStatus = [20, 30, 40]
                this.outnotifyType = data.outnotifyType

                service.selLadOutnotifyByAllId(param).then((res) => {
                    if (res.code == "200") {
                        let data = res.data;
                        this.totalPack = ""
                        this.totalAmount = ""
                        this.isshowbook = true
                        this.outnotify = data
                        this.outnotify.cargoName = cargosName

                        if (this.outnotifyType == 30) {
                            this.isshowbook = false
                            this.totalPack = data == null || data == undefined ? 0 : data.totalPack + "包"
                            this.totalAmount = data == null || data == undefined ? 0 : data.totalAmount + "件"
                        } else {
                            this.totalAmount = data == null || data == undefined ? 0 : data.totalAmount + "件"

                        }

                        if (data.sort != null) {
                            this.showQueue = true
                            this.queueData.sort = data.sort - 1
                            this.queueData.warehouseDpoint = data.warehouseDpoint
                            this.queueData.curStatus = this.formatQueueStatus(data.curStatus)
                        } else {
                            this.showQueue = false
                        }

                        this.showpop = true
                    } else {

                        Toast(res.message)
                    }

                }).catch((res) => {
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            formatQueueStatus(status) {
                if (status == 20) {
                    return '排队中'
                } else if (status == 30) {
                    return '进库准备'
                } else if (status == 40) {
                    return '装车中'
                } else {
                    return ''
                }
            },
            showImg(item) {
                ImagePreview([item]);
            },
            showWarrantyBook() {
                this.showWarrantypop = true;
                this.title = "质保书"
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.onLoad();

            },
            onRefresh() {
                this.onLoad();

            },
            detailDel() {
                this.showpop = false
            },
            onLoad() {
                let param = {}
                param.limit = 10
                param.page = this.page
                param.key = this.key
                param.outnotifyStatus = 20
                param.deliveryName = localStorage.getItem("deliveryName")
                param.deliveryIdnumber = localStorage.getItem("deliveryIdnumber")
                service.selLadOutnotifyListP(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }

                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                }).catch((res) => {
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
        }
    }
</script>

<style scoped>
    .van-cell {

    }

    .van-popup {
        background-color: #f7f8fa;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 46px auto;
    }

    .qrcode {
        margin: 10px auto; /* 居中 这个是必须的，，其它的属性非必须 */
        width: 180px; /* 给个宽度 顶到浏览器的两边就看不出居中效果了 */
        text-align: center; /* 文字等内容居中 */
    }

    /*.swipewarp{*/
    /*    height: 100px;*/
    /*}*/

    .contentwarp {
        height: calc(100vh - 50px);
    }

    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 50px;
        height: 50px;
        width: 100% !important;
    }

    .closebutton2 {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        z-index: 9999;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;

    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;

    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /deep/ .van-cell__title {
        text-align: left;
        /*font-weight: bolder;*/
    }

    .cellwarp {
        padding-top: 0px;
        padding-bottom: 0px;
        font-weight: bolder;
        padding-left: 0px;
    }

    .cellitemwarp {
        padding-top: 8px;
        padding-bottom: 8px;
    }

    a {
        color: #6685a4;;
    }

    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
        width: 90px;
        color: #969799;
    }

    /deep/ .van-cell__value {
        color: #323233;
    }

    /deep/ .yqsm .van-cell__value {
        text-align: left;
    }
    .van-address-list__bottom {
        position: fixed;
        bottom: 12px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
        /*background-color: #fff;*/
    }
    .pdzt .pdzt-cell{
        padding: 10px 16px;
        font-size: 14px;
        line-height: 24px;
    }
    .pdzt .pdzt-cell.pdzt-cell-x{
        padding-top:0;
    }
</style>
